<app-login-base pageHeader="Welcome to the Dooya Trading Portal!">
        <form class="text-center p-5 w-100" (ngSubmit)="ConfirmRegistration()">                                                    
            <p class="mb-4">Give us a moment while we get things ready for you!</p>

            <!--Error Display-->
            <div *ngIf="showError" class="alert alert-danger" role="alert">
                Unable to confirm registration, either the link has expired or an error occured
            </div>

            <!--Success Display-->
            <div *ngIf="showSuccess" class="alert alert-success" role="alert">
                Registration Confirmed, you will be taken to the password page shortly...
            </div>

            <!--Loading display-->
            <app-loading [busy]="busy"></app-loading>
        </form>
</app-login-base>               